<template>
  <div class="main-thumbnails lightgallery-thumbnails" v-if="items.length">
    <div v-for="(image, i) in items" :key="i" @click.prevent="open(i)" :data-src="image" class="main-thumbnails-item">
      <img :src="image" onerror="this.src = '/img/main-thumb.png'" style="width: 100%;" alt/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    open(i) {
      const el = $(".main-slider-item")[i]
      $(el).trigger('click');

      setTimeout(() => {
        window.location.hash = '#lg=1&slide=' + i;
      }, 500);
    },
  }
}
</script>